/* Privacy-safe internal promotion tracking.
 *
 * Every [data-promotion-id] element emits:
 * - a local `repubblica:promotion` DOM event for theme integrations;
 * - a namespaced Shopify Customer Events event for configured web pixels;
 * - GA4-compatible dataLayer events when a dataLayer already exists;
 * - concise Microsoft Clarity events/tags when Clarity is available.
 *
 * Payloads intentionally exclude search terms, cart contents and customer data.
 */
(function () {
  var selector = '[data-promotion-id]';
  var viewed = typeof WeakSet === 'function' ? new WeakSet() : null;
  var SHOPIFY_EVENTS = {
    view_promotion: 'repubblica:promotion_viewed',
    select_promotion: 'repubblica:promotion_selected'
  };

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
      try {
        return privacy.analyticsProcessingAllowed();
      } catch (error) {
        return false;
      }
    }
    return false;
  }

  function promotionData(element, eventName) {
    var action = element.matches('a[href]') ? element : element.querySelector('[data-promotion-action][href]');
    var mobileSlot = element.getAttribute('data-promotion-slot-mobile');
    var useMobileSlot = mobileSlot && window.matchMedia && window.matchMedia('(max-width: 1007px)').matches;
    return {
      event_name: eventName,
      promotion_id: element.getAttribute('data-promotion-id') || '',
      promotion_name: element.getAttribute('data-promotion-name') || '',
      creative_name: element.getAttribute('data-promotion-creative') || '',
      creative_slot: useMobileSlot ? mobileSlot : (element.getAttribute('data-promotion-slot') || ''),
      destination: action ? action.getAttribute('href') : ''
    };
  }

  function ga4Item(data) {
    return {
      promotion_id: data.promotion_id,
      promotion_name: data.promotion_name,
      creative_name: data.creative_name,
      creative_slot: data.creative_slot
    };
  }

  function publishShopify(eventName, data) {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    try {
      var result = analytics.publish(SHOPIFY_EVENTS[eventName], data);
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (error) {}
  }

  function publishClarity(eventName, data) {
    if (typeof window.clarity !== 'function') return;
    try {
      window.clarity('set', 'promotion_id', data.promotion_id);
      window.clarity('set', 'promotion_slot', data.creative_slot);
      window.clarity('event', data.promotion_id + '_' + (eventName === 'view_promotion' ? 'view' : 'select'));
    } catch (error) {}
  }

  function publish(element, eventName) {
    var data = promotionData(element, eventName);
    if (window.RPExperience) data = window.RPExperience.enrich(data);

    document.dispatchEvent(new CustomEvent('repubblica:promotion', { detail: data }));
    if (!analyticsAllowed()) return;

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: eventName,
        ecommerce: {
          creative_name: data.creative_name,
          creative_slot: data.creative_slot,
          promotion_id: data.promotion_id,
          promotion_name: data.promotion_name,
          items: [ga4Item(data)]
        }
      });
    }

    publishShopify(eventName, data);
    publishClarity(eventName, data);

    if (eventName === 'select_promotion') {
      try {
        sessionStorage.setItem('repubblica:last_promotion', JSON.stringify({
          promotion_id: data.promotion_id,
          creative_slot: data.creative_slot,
          selected_at: Date.now()
        }));
      } catch (error) {}
    }
  }

  function markViewed(element) {
    if (viewed && viewed.has(element)) return;
    if (!viewed && element.getAttribute('data-promotion-viewed') === 'true') return;
    if (viewed) viewed.add(element);
    element.setAttribute('data-promotion-viewed', 'true');
    publish(element, 'view_promotion');
  }

  function observeViews() {
    var elements = document.querySelectorAll(selector);
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(elements, markViewed);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.35) return;
        markViewed(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: [0.35] });

    Array.prototype.forEach.call(elements, function (element) { observer.observe(element); });
  }

  document.addEventListener('click', function (event) {
    var action = event.target.closest('[data-promotion-action], ' + selector + '[href]');
    if (!action) return;
    var promotion = action.closest(selector);
    if (promotion) publish(promotion, 'select_promotion');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeViews, { once: true });
  } else {
    observeViews();
  }
})();
